import type { ReactNode } from 'react';
import type { BookingDocument } from '../types';
import { BookingDocuments } from './BookingDocuments';
import { FIELD, fieldBorder } from './UI';
import { ItemDetailsSection } from './SavedItemDetails';

/** Same capture order for transport, accommodation and Shortlist bookings. */
export function BookingDetailsForm({ booked, onBookedChange, source, onSourceChange, reference, onReferenceChange,
  notes, onNotesChange, documents, children, sourcePlaceholder = 'Where did you book?' }: {
  booked: boolean; onBookedChange: (value: boolean) => void;
  source: string; onSourceChange: (value: string) => void;
  reference: string; onReferenceChange: (value: string) => void;
  notes: string; onNotesChange: (value: string) => void;
  documents?: BookingDocument[]; children: ReactNode; sourcePlaceholder?: string;
}) {
  return <ItemDetailsSection label="Booking & payment">
    {children}
    <label className="flex min-h-11 items-center gap-3 text-sm text-app-text">
      <input type="checkbox" checked={booked} onChange={e => onBookedChange(e.target.checked)} className="accent-gold w-4 h-4" />
      Booking / reservation confirmed
    </label>
    {booked && <>
      <label className="block space-y-1.5"><span className="ds-label block">Booking source</span>
        <input value={source} onChange={e => onSourceChange(e.target.value)} placeholder={sourcePlaceholder} className={`${FIELD} ${fieldBorder(false, true)}`} />
      </label>
      <label className="block space-y-1.5"><span className="ds-label block">Confirmation number</span>
        <input value={reference} onChange={e => onReferenceChange(e.target.value)} className={`${FIELD} ${fieldBorder(false, true)}`} />
      </label>
      <BookingDocuments docs={documents} />
      <label className="block space-y-1.5"><span className="ds-label block">Booking notes</span>
        <textarea value={notes} onChange={e => onNotesChange(e.target.value)} placeholder="Cancellation terms, payment deadlines or booking instructions…" className={`${FIELD} ${fieldBorder(false, true)} min-h-[80px] resize-none`} />
      </label>
    </>}
  </ItemDetailsSection>;
}
